import { Text, Box, VStack } from '@chakra-ui/react'
import TextContentAbout from '../components/TextContentAbout'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'
import aboutImage from '../assets/about/about.jpg'
import aboutSlideshow1 from '../assets/about/about-slideshow-1.jpg'
import aboutSlideshow2 from '../assets/about/about-slideshow-2.jpg'
import aboutSlideshow3 from '../assets/about/about-slideshow-3.jpg'


const examplePics = [
  aboutSlideshow1,
  aboutSlideshow2,
  aboutSlideshow3,
  
]

const textContent = [
    {
      type: 'image',
      content: aboutImage
    },
    {
      type: 'subTitle',
      content: 'about.subtitle',
    },
    {
      type: 'content',
      content: 'about.goal',
    },
    {
      type: 'list',
      content: 'about.why',
      listElements: [
          'about.benefit1',
          'about.benefit2',
          'about.benefit3'
      ]
    },
    {
      type: 'carousel',
      content: '',
      listElements: examplePics
    },
    {
      type: 'subTitle',
      content: 'about.historyTitle',
    },
    {
      type: 'content',
      content: 'about.history1'
    },
    {
      type: 'content',
      content: 'about.history2'
    },
    {
      type: 'content',
      content: 'about.join'
    },
    {
      type: 'content',
      content: 'about.thanks'
    }

]

const AboutPage = () => {
  const { t } = useTranslation()
  const translatedTextContent = textContent.map((item) => ({
    ...item,
    content: item.type === 'image' || item.type === 'carousel' ? item.content : t(item.content),
    listElements: item.listElements?.map((listItem) => t(listItem)),
  }))

  return (
    <>
        <Box
            bg={'#f5f5f7'}
            width={'100%'}
            position="relative"
            padding={{ base: '12vh 5vw 8vh', md: '12vh 5vw 10vh' }}
             >
                <VStack
                    width={'100%'}
                    maxW={'1180px'}
                    margin={'auto'}
                    spacing={{ base: 6, md: 10 }}
                  >
                    <Text
                        fontSize={{ base: '3xl', md: '4xl' }}
                        fontFamily={'heading'}
                        fontWeight={'bold'}
                        letterSpacing={'-0.04em'}
                        textAlign="center"
                        >{t('about.title')}</Text>
                        <Box
                          bg={'white'}
                          borderRadius={{ base: '24px', md: '32px' }}
                          w={'100%'}
                          padding={{ base: '7vw', md: '5vw' }}
                          boxShadow={'0 18px 50px rgba(25, 25, 35, 0.08)'}>
                            <VStack spacing={{ base: 8, md: 12 }}>
                            {
                              translatedTextContent.map((item, index) => {
                                return (
                                  <TextContentAbout
                                    type={item.type}
                                    content={item.content}
                                    key={index}
                                    listElements={item.listElements}
                                  />
                                )
                              })
                            }
                            </VStack>
                        </Box>

                </VStack>

        </Box>
        <Footer></Footer>

    </>
  )
}

export default AboutPage
